import React, { useState } from 'react';
import { NavAndTabs } from '../../components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const BookAnAppointment = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(id || "specialist-list");

    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/book-an-appointment/${tabId}`);
    };
    const tabs = [
        {
            id: "clinics-list",
            label: t("clinics_list"),
            // content: (
            //     <Tabbles.TableBlk
            //         headerIcon={<PiCalendar className="header-Icn" />}
            //         heading={t("appointments.requested.page-heading")}
            //         // subHeading="Today, 8th August 2024"

            //         subHeading={
            //             <span>
            //                 {t("From")}, {startDate} - {endDate}
            //             </span>
            //         }
            //         columns={[
            //             `${t("patient_name")}`,
            //             `${t("booking_id")}`,
            //             `${t("clinics_name")}`,
            //             `${t("medical_specialty")}`,
            //             `${t("patient_details")}`,
            //             `${t("time_&_date")}`,
            //             `${t("location")}`,
            //             `${t("accept")}`,
            //             `${t("decline")}`,
            //         ]}
            //         data={appointmentRequestData?.map((appointment) => ({
            //             [t("patient_name")]: (
            //                 <div className="d-flex align-items-center">
            //                     <Badges.Badge1
            //                         text={appointment.externalUser ? "G" : "E"}
            //                         className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
            //                             }`}
            //                     />{" "}
            //                     {appointment.patientFirstName +
            //                         " " +
            //                         appointment.patientLastName}
            //                 </div>
            //             ),
            //             [t("booking_id")]: appointment.bookingId,
            //             [t("clinics_name")]: appointment.clinicName,
            //             [t("medical_specialty")]: appointment.physicianServices,
            //             [t("patient_details")]: (
            //                 <div className="editBlkIcon">
            //                     <PiFolderOpen
            //                         className="editIcon"
            //                         onClick={() => postBookedAppointment(appointment, true)}
            //                     />
            //                 </div>
            //             ),
            //             [t("time_&_date")]: (
            //                 <>
            //                     <div>
            //                         {new Date(appointment.appointmentDateTime).toLocaleTimeString(
            //                             "en-US",
            //                             {
            //                                 hour: "2-digit",
            //                                 minute: "2-digit",
            //                                 hour12: true,
            //                             }
            //                         )}
            //                     </div>
            //                     <div>
            //                         {new Date(appointment.appointmentDateTime)
            //                             .toLocaleDateString("en-GB")
            //                             .replace(/\//g, " - ")}
            //                     </div>
            //                 </>
            //             ),
            //             [t("location")]: appointment.appointmentType,
            //             [t("accept")]: (
            //                 <div className="editBlkIcon">
            //                     <PiThumbsUp
            //                         className="editIcon"
            //                         onClick={() => handleAcceptReject(appointment, true)}
            //                     />
            //                 </div>
            //             ),
            //             [t("decline")]: (
            //                 <PiTrash
            //                     className="delIcon noVerify"
            //                     onClick={() => handleAcceptReject(appointment, false)}
            //                 />
            //             ),
            //         }))}
            //         tabbleClassname="tabble"
            //         noDataMessage={t("appointments.no_appointments_available")}
            //     />
            // ),
            disabled: false,
        },
        {
            id: "specialist-list",
            label: `${t("specialist_list")}`,
            // content: (
            //     <Tabbles.TableBlk
            //         headerIcon={<PiCalendar className="header-Icn" />}
            //         heading={t("appointments.requested.page-heading")}
            //         subHeading={
            //             <span>
            //                 {t("From")}, {startDate} - {endDate}
            //             </span>
            //         }
            //         columns={[
            //             `${t("patient_name")}`,
            //             `${t("doctor_name")}`,
            //             `${t("medical_specialty")}`,
            //             `${t("patient_details")}`,
            //             `${t("time_&_date")}`,
            //             `${t("location")}`,
            //             `${t("accept")}`,
            //             `${t("decline")}`,
            //         ]}
            //         data={getAppointmentsData?.result?.patientAppointments.map(
            //             (appointment) => ({
            //                 [t("patient_name")]: (
            //                     <div className="d-flex align-items-center">
            //                         <Badges.Badge1
            //                             text={appointment.externalUser ? "G" : "E"}
            //                             className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
            //                                 }`}
            //                         />{" "}
            //                         {appointment.patientFirstName +
            //                             " " +
            //                             appointment.patientLastName}
            //                     </div>
            //                 ),
            //                 [t("doctor_name")]:
            //                     appointment.doctorFirstName + " " + appointment.doctorLastName,
            //                 [t("medical_specialty")]: appointment.physicianServices,
            //                 [t("patient_details")]: (
            //                     <div className="editBlkIcon">
            //                         <PiFolderOpen
            //                             className="editIcon"
            //                             onClick={() => postBookedAppointment(appointment, true)}
            //                         />
            //                     </div>
            //                 ),
            //                 [t("time_&_date")]: (
            //                     <>
            //                         <div>
            //                             {new Date(
            //                                 appointment.appointmentDateTime
            //                             ).toLocaleTimeString("en-US", {
            //                                 hour: "2-digit",
            //                                 minute: "2-digit",
            //                                 hour12: true,
            //                             })}
            //                         </div>
            //                         <div>
            //                             {new Date(appointment.appointmentDateTime)
            //                                 .toLocaleDateString("en-GB")
            //                                 .replace(/\//g, " - ")}
            //                         </div>
            //                     </>
            //                 ),
            //                 [t("location")]: appointment.appointmentType,
            //                 [t("accept")]: (
            //                     <div className="editBlkIcon">
            //                         <PiThumbsUp
            //                             className="editIcon"
            //                             onClick={() => handleAcceptReject(appointment, true)}
            //                         />
            //                     </div>
            //                 ),
            //                 [t("decline")]: (
            //                     <PiTrash
            //                         className="delIcon noVerify"
            //                         onClick={() => handleAcceptReject(appointment, false)}
            //                     />
            //                 ),
            //             })
            //         )}
            //         tabbleClassname="tabble"
            //         noDataMessage={t("appointments.no_appointments_available")}
            //     />
            // ),
            disabled: false,
        },
    ];
    return (
        <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
        />
    )
}

export default BookAnAppointment;
